import { enableProdMode } from "@angular/core";
import { environment } from "src/environments/environment"

declare var gtag : any;

export function googleAnalyticsTracker(googleAnalyticsKey: string) {
    if (environment.production) {
        gtag('event', googleAnalyticsKey, {
            'event_category': 'BUTTON_CLICK',
            'event_label': 'ADDs Clicks Count',
            'value': 'Put a value here that is meaningful with respect to the click event'
        })

        enableProdMode();
    }
}

